window.MEN_COLLECTION = [
  "https://www.baltini.com/collections/new-in",
  "https://www.baltini.com/collections/men",
  "https://www.baltini.com/collections/new-arrivals-1",
  "https://www.baltini.com/collections/sale-1",
  "https://www.baltini.com/collections/clothing",
  "https://www.baltini.com/collections/coats-jackets",
  "https://www.baltini.com/collections/jeans",
  "https://www.baltini.com/collections/trousers",
  "https://www.baltini.com/collections/shirts",
  "https://www.baltini.com/collections/suits",
  "https://www.baltini.com/collections/sweaters",
  "https://www.baltini.com/collections/swimwear",
  "https://www.baltini.com/collections/topwear",
  "https://www.baltini.com/collections/shoes-1",
  "https://www.baltini.com/collections/boots-1",
  "https://www.baltini.com/collections/laced-up",
  "https://www.baltini.com/collections/loafers-1",
  "https://www.baltini.com/collections/sandals-1",
  "https://www.baltini.com/collections/sneakers-1",
  "https://www.baltini.com/collections/bags-2",
  "https://www.baltini.com/collections/backpacks-1",
  "https://www.baltini.com/collections/belt-bags-1",
  "https://www.baltini.com/collections/shoulder-bags-1",
  "https://www.baltini.com/collections/totes-1",
  "https://www.baltini.com/collections/accessories-1",
  "https://www.baltini.com/collections/belts-1",
  "https://www.baltini.com/collections/eyewear-1",
  "https://www.baltini.com/collections/hats-1",
  "https://www.baltini.com/collections/jewelry-1",
  "https://www.baltini.com/collections/scarves",
  "https://www.baltini.com/collections/small-leather-goods-1",
];
window.WOMEN_COLLECTION = [
  "https://www.baltini.com/collections/new-in",
  "https://www.baltini.com/collections/women",
  "https://www.baltini.com/collections/new-arrivals",
  "https://www.baltini.com/collections/sale-2",
  "https://www.baltini.com/collections/womens-clothing",
  "https://www.baltini.com/collections/womens-coats-jackets",
  "https://www.baltini.com/collections/womens-dresses",
  "https://www.baltini.com/collections/womens-jumpsuits-1",
  "https://www.baltini.com/collections/womens-jeans",
  "https://www.baltini.com/collections/womens-lingerie",
  "https://www.baltini.com/collections/womens-pants-shorts",
  "https://www.baltini.com/collections/womens-shirts",
  "https://www.baltini.com/collections/womens-skirts",
  "https://www.baltini.com/collections/womens-skirts",
  "https://www.baltini.com/collections/womens-sweaters-1",
  "https://www.baltini.com/collections/womens-swimwear",
  "https://www.baltini.com/collections/womens-topwear",
  "https://www.baltini.com/collections/shoes",
  "https://www.baltini.com/collections/boots",
  "https://www.baltini.com/collections/flat-shoes",
  "https://www.baltini.com/collections/heels-1",
  "https://www.baltini.com/collections/laced-shoes",
  "https://www.baltini.com/collections/loafers",
  "https://www.baltini.com/collections/pumps",
  "https://www.baltini.com/collections/sandals",
  "https://www.baltini.com/collections/sneakers",
  "https://www.baltini.com/collections/wedges",
  "https://www.baltini.com/collections/bags",
  "https://www.baltini.com/collections/backpacks",
  "https://www.baltini.com/collections/belt-bags",
  "https://www.baltini.com/collections/clutches",
  "https://www.baltini.com/collections/handbags",
  "https://www.baltini.com/collections/bags-1",
  "https://www.baltini.com/collections/shoulder-bags",
  "https://www.baltini.com/collections/totes",
  "https://www.baltini.com/collections/accessories",
  "https://www.baltini.com/collections/belts",
  "https://www.baltini.com/collections/eyewear",
  "https://www.baltini.com/collections/hats",
  "https://www.baltini.com/collections/jewelry",
  "https://www.baltini.com/collections/scarves-wraps",
  "https://www.baltini.com/collections/small-leather-goods",
  "https://www.baltini.com/collections/other-accessories",
];
window.BOYS_COllECTION = [
  "https://www.baltini.com/collections/new-arrivals-2",
  "https://www.baltini.com/collections/kids",
  "https://www.baltini.com/collections/kids-sale",
  "https://www.baltini.com/collections/boys-1",
  "https://www.baltini.com/collections/boys-clothing",
  "https://www.baltini.com/collections/boys-shoes",
];
window.GIRLS_COLLECTION = [
  "https://www.baltini.com/collections/new-arrivals-2",
  "https://www.baltini.com/collections/kids",
  "https://www.baltini.com/collections/kids-sale",
  "https://www.baltini.com/collections/girls-above-2-years",
  "https://www.baltini.com/collections/girls-clothing",
  "https://www.baltini.com/collections/girls-shoes",
];

window.MEN_CATEGORY_COLLECTION_MAPPING = {
  "https://www.baltini.com/collections/clothing": "CLOTHING",
  "https://www.baltini.com/collections/shoes-1": "SHOES",
  "https://www.baltini.com/collections/bags-2": "BAGS",
  "https://www.baltini.com/collections/accessories-1": "ACCESSORIES",
};

window.MEN_SUBCATEGORY_COLLECTION_MAPPING = {
  "https://www.baltini.com/collections/coats-jackets": '"COATS & JACKETS"',
  "https://www.baltini.com/collections/jeans": "JEANS",
  "https://www.baltini.com/collections/trousers": '"PANTS & SHORTS"',
  "https://www.baltini.com/collections/shirts": "SHIRTS",
  "https://www.baltini.com/collections/suits": "SUITS",
  "https://www.baltini.com/collections/sweaters": "SWEATERS",
  "https://www.baltini.com/collections/swimwear": "SWIMWEAR",
  "https://www.baltini.com/collections/topwear": "TOPWEAR",
  "https://www.baltini.com/collections/boots-1": "BOOTS",
  "https://www.baltini.com/collections/laced-up": '"LACED UP"',
  "https://www.baltini.com/collections/loafers-1": "LOAFERS",
  "https://www.baltini.com/collections/sandals-1": "SANDALS",
  "https://www.baltini.com/collections/sneakers-1": "SNEAKERS",
  "https://www.baltini.com/collections/backpacks-1": "BACKPACKS",
  "https://www.baltini.com/collections/belt-bags-1": '"BELT BAGS"',
  "https://www.baltini.com/collections/shoulder-bags-1": '"SHOULDER BAGS"',
  "https://www.baltini.com/collections/other-bags": '"OTHER BAGS"',
  "https://www.baltini.com/collections/totes-1": "TOTES",
  "https://www.baltini.com/collections/belts-1": "BELTS",
  "https://www.baltini.com/collections/eyewear-1": "EYEWEAR",
  "https://www.baltini.com/collections/hats-1": "HATS",
  "https://www.baltini.com/collections/jewelry-1": "JEWELRY",
  "https://www.baltini.com/collections/scarves": "SCARVES",
  "https://www.baltini.com/collections/small-leather-goods-1":
    '"SMALL LEATHER GOODS"',
};

window.WOMEN_CATEGORY_COLLECTION_MAPPING = {
  "https://www.baltini.com/collections/womens-clothing": "CLOTHING",
  "https://www.baltini.com/collections/shoes": "SHOES",
  "https://www.baltini.com/collections/bags": "BAGS",
  "https://www.baltini.com/collections/accessories": "ACCESSORIES",
};

window.WOMEN_SUBCATEGORY_COLLECTION_MAPPING = {
  "https://www.baltini.com/collections/womens-coats-jackets":
    '"COATS & JACKETS"',
  "https://www.baltini.com/collections/womens-dresses": "DRESSES",
  "https://www.baltini.com/collections/womens-jumpsuits-1": "JUMPSUITS",
  "https://www.baltini.com/collections/womens-jeans": "JEANS",
  "https://www.baltini.com/collections/womens-lingerie": "LINGERIE",
  "https://www.baltini.com/collections/womens-pants-shorts": '"PANTS & SHORTS"',
  "https://www.baltini.com/collections/womens-shirts": "SHIRTS",
  "https://www.baltini.com/collections/womens-skirts": "SKIRTS",
  "https://www.baltini.com/collections/womens-sweaters-1": "SWEATERS",
  "https://www.baltini.com/collections/womens-swimwear": "SWIMWEAR",
  "https://www.baltini.com/collections/womens-topwear": "TOPWEAR",
  "https://www.baltini.com/collections/boots": "BOOTS",
  "https://www.baltini.com/collections/flat-shoes": "FLATS",
  "https://www.baltini.com/collections/heels-1": "HEELS",
  "https://www.baltini.com/collections/laced-shoes": '"LACED UP"',
  "https://www.baltini.com/collections/loafers": "LOAFERS",
  "https://www.baltini.com/collections/pumps": "PUMPS",
  "https://www.baltini.com/collections/sandals": "SANDALS",
  "https://www.baltini.com/collections/sneakers": "SNEAKERS",
  "https://www.baltini.com/collections/wedges": "WEDGES",
  "https://www.baltini.com/collections/backpacks": "BACKPACKS",
  "https://www.baltini.com/collections/belt-bags": '"BELT BAGS"',
  "https://www.baltini.com/collections/clutches": "CLUTCHES",
  "https://www.baltini.com/collections/handbags": "HANDBAGS",
  "https://www.baltini.com/collections/shoulder-bags": '"SHOULDER BAGS"',
  "https://www.baltini.com/collections/totes": "TOTES",
  "https://www.baltini.com/collections/bags-1": '"OTHER BAGS"',
  "https://www.baltini.com/collections/belts": "BELTS",
  "https://www.baltini.com/collections/eyewear": "EYEWEAR",
  "https://www.baltini.com/collections/hats": "HATS",
  "https://www.baltini.com/collections/jewelry": "JEWELRY",
  "https://www.baltini.com/collections/scarves-wraps": '"SCARVES & WRAPS"',
  "https://www.baltini.com/collections/small-leather-goods":
    '"SMALL LEATHER GOODS"',
  "https://www.baltini.com/collections/other-accessories":
    '"OTHER ACCESSORIES"',
};

document.addEventListener("algolia.hooks.initialize", function () {
  algoliaShopify.hooks.registerHook(
    "beforeInstantSearchConfigurationOptions",
    function (options) {
      let genders = [];
      if (MEN_COLLECTION.includes(currentUrl)) {
        genders.push("MEN");
      }
      if (BOYS_COllECTION.includes(currentUrl)) {
        genders.push("BOYS");
      }
      if (WOMEN_COLLECTION.includes(currentUrl)) {
        genders.push("WOMEN");
      }
      if (GIRLS_COLLECTION.includes(currentUrl)) {
        genders.push("GIRLS");
      }

      options.indexName = "shopify_products";
      options.maxValuesPerFacet = 1000;
      options.maxFacetHits = 100;
      options.initialUiState = {
        sortBy: "shopify_products",
        shopify_products: {
          sortBy: "shopify_products",
          refinementList: {
            "named_tags.Gender": genders,
          },
        },
      };
      return options;
    }
  );
  algoliaShopify.hooks.registerHook(
    "beforeInstantSearchFiltersString",
    function (defaultFilter) {
      const currentUrl = window.location.href.split("?")[0];
      let genders = [];
      let filter = defaultFilter;
      let additionalFilter = " AND";
      let categories = [];
      let subcategories = [];
      if (MEN_COLLECTION.includes(currentUrl)) {
        genders.push("MEN");
      }
      if (BOYS_COllECTION.includes(currentUrl)) {
        genders.push("BOYS");
      }
      if (WOMEN_COLLECTION.includes(currentUrl)) {
        genders.push("WOMEN");
      }
      if (GIRLS_COLLECTION.includes(currentUrl)) {
        genders.push("GIRLS");
      }
      if (MEN_CATEGORY_COLLECTION_MAPPING[currentUrl]) {
        categories.push(MEN_CATEGORY_COLLECTION_MAPPING[currentUrl]);
      }
      if (MEN_SUBCATEGORY_COLLECTION_MAPPING[currentUrl]) {
        subcategories.push(MEN_SUBCATEGORY_COLLECTION_MAPPING[currentUrl]);
      }
      if (WOMEN_CATEGORY_COLLECTION_MAPPING[currentUrl]) {
        categories.push(WOMEN_CATEGORY_COLLECTION_MAPPING[currentUrl]);
      }
      if (WOMEN_SUBCATEGORY_COLLECTION_MAPPING[currentUrl]) {
        subcategories.push(WOMEN_SUBCATEGORY_COLLECTION_MAPPING[currentUrl]);
      }
      if (genders.length > 0) {
        genders.length > 1
          ? (filter =
              filter +
              ` AND (${genders
                .map((x) => `named_tags.Gender:${x}`)
                .join(" OR ")})`)
          : (filter = filter + ` AND named_tags.Gender: ${genders[0]}`);
      }
      if (categories.length > 0) {
        categories.length > 1
          ? (filter =
              filter +
              ` AND (${categories
                .map((x) => `named_tags.ACategory:${x}`)
                .join(" OR ")})`)
          : (filter = filter + ` AND named_tags.ACategory: ${categories[0]}`);
      }
      if (subcategories.length > 0) {
        subcategories.length > 1
          ? (filter =
              filter +
              ` AND (${subcategories
                .map((x) => `named_tags.ASubCategory:${x}`)
                .join(" OR ")})`)
          : (filter =
              filter + ` AND named_tags.ASubCategory: ${subcategories[0]}`);
      }
      return filter;
    }
  );
  algoliaShopify.hooks.registerHook(
    "beforeInstantSearchMainTemplate",
    function (_defaultTemplate, data, html) {
      return html`
        <div class="ais-page">
          <h1 class="ais-h2">${algoliaShopify.translations.searchTitle}</h1>
          <div class="ais-input">
            <div class="ais-search-box-container"></div>
            <div class="ais-input-button">
              <div class="ais-clear-input-icon"></div>
            </div>
          </div>
          <div class="ais-facets-button">Show filters</div>
          <div class="ais-facets">
            <div class="ais-clear-refinements-container"></div>
            <div class="ais-current-refined-values-container"></div>
            ${data.facets.map(
              (facet) =>
                html`
                  <div
                    class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName}"
                  >
                    <label
                      for="${facet.escapedName}"
                      class="ais-range-slider--header ais-facet--header ais-header"
                      >${facet.title}</label
                    >
                    <input
                      class="ais-dropdown-checkbox"
                      type="checkbox"
                      id="${facet.escapedName}"
                      name="dropdown"
                    />
                    <div
                      class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container"
                    ></div>
                  </div>
                `
            )}
            <div class="ais-facets-button-close">
              APPLY FILTERS
            </div>
          </div>
          <div class="ais-block">
            <div class="ais-search-header">
              <div></div>
              <div class="ais-change-display">
                <span
                  class="ais-change-display-block ais-change-display-selected"
                  ><i class="fa fa-th-large"></i
                ></span>
                <span class="ais-change-display-list"
                  ><i class="fa fa-th-list"></i
                ></span>
              </div>
              <div class="ais-sort">
                ${
                  data.multipleSortOrders
                    ? html`
                      ${algoliaShopify.translations.sortBy}
                      <span class="ais-sort-orders-container"></span>
                    `
                    : html`
                      ${algoliaShopify.translations.sortBy}
                      ${algoliaShopify.translations.relevance}
                    `
                }
              </div>
            </div>
            <div class="ais-hits-container ais-results-as-block"></div>
            <div class="ais-stats-container"></div>
          </div>
          <div class="ais-pagination-container"></div>
        </div>
      `;
    }
  );

  const { infiniteHits, stats } = window.instantsearch.widgets;
  const sessionStorageCache =
    window.instantsearch.createInfiniteHitsSessionStorageCache();
  algoliaShopify.hooks.registerHook("beforeISStartAddWidgetArray", function () {
    const infiniteHitsWidget = infiniteHits({
      container: ".ais-hits-container",
      templates: {
        item(hit, { html, components }) {
          function templateProduct(hit, html, components) {
            const customDisplayPrice = function (product, t) {
              var priceInCents = product.variants_min_price * 100;

              if (
                typeof Shopify !== "undefined" &&
                typeof Shopify.currency !== "undefined" &&
                typeof Shopify.currency.rate !== "undefined" &&
                typeof Shopify.currency.active !== "undefined"
              ) {
                // Convert to "presentment" currency using the rate provided by Shopify
                priceInCents = priceInCents * Shopify.currency.rate;
                // Round up to the nearest whole number keeping in accordance with
                // the default rounding strategy of Shopify
                priceInCents = Math.ceil(priceInCents);
              }

              if (Shopify.currency.active === "EUR") {
                var vat = (priceInCents * 22) / 100;
                priceInCents = priceInCents + vat;
              }

              /* Shopify uses different rounding strategies for different currencies.
               * The logic below might need to be customised based on the active currencies.
               * Note: Please only include currencies other than your store currency.
               */
              // Round up to the 95th cent for EUR
              if (Shopify.currency.active === "EUR") {
                priceInCents = parseInt(priceInCents / 100, 10) * 100 + 95;
              }

              var finalPrice = priceInCents / 100;

              if (
                ["HKD", "SGD", "CAD", "GBP", "AUD"].includes(
                  Shopify.currency.active
                )
              ) {
                finalPrice = Math.ceil(finalPrice).toFixed(2);
              } else if (Shopify.currency.active === "USD") {
                finalPrice = finalPrice.toFixed(2);
              } else {
                finalPrice = finalPrice.toFixed(2);
              }
              var priceFmt = String(finalPrice) // always two decimal digits
                .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
              return window.Shopify.currency.active + " " + priceFmt;
            };

            const customDisplayStrikedPrice = function (
              final_price,
              compare_price
            ) {
              var price =
                (compare_price > final_price ? compare_price : final_price) *
                window.Shopify.currency.rate;

              if (
                ["HKD", "SGD", "CAD", "GBP", "AUD"].includes(
                  Shopify.currency.active
                )
              ) {
                price = Math.ceil(price).toFixed(2);
              } else if (Shopify.currency.active === "USD") {
                price = price.toFixed(2);
              } else {
                price = price.toFixed(2);
              }
              var priceFmt = String(price) // always two decimal digits
                .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
              return window.Shopify.currency.active + " " + priceFmt;
            };

            const costumDisplayImage = function (hit) {
              const r = hit.product_image;
              if (r)
                return "original" === t
                  ? r
                  : r.replace(/\/(.*)\.(\w{2,4})/g, `/$1_${t}.$2`);
              else {
                return hit.meta.product.product_images[0]
                  ? hit.meta.product.product_images[0]
                  : "http://cdn.shopify.com/s/images/admin/no-image-compact.gif";
              }
            };

            
            const placeholderImg = "http://cdn.shopify.com/s/images/admin/no-image-compact.gif";
            let defaultImg = algoliaShopify.helpers.largeImage(hit);

            // Jika gambar default adalah placeholder, anggap saja null
            if (defaultImg === placeholderImg || !defaultImg) {
                defaultImg = null;
            }
            
            let imgsrc = defaultImg ?? 
                         hit.image ??
                         hit.product_image ??
                         hit.meta?.product?.product_images?.[0] ??
                         hit.meta?.product?.original_product_images?.[0] ??
                         hit.meta?.product?.original_product_images?.[1] ??
                         placeholderImg; // Fallback terakhir

            if (hit.handle.includes('low-brand-vest-double-vest')) {
             const metaImagesProduct = hit.meta?.product?.original_product_images;
             if (metaImagesProduct && metaImagesProduct.length >= 3) {
                 imgsrc = metaImagesProduct[3];
             }
            }

            let location;
            let handle = "";
            let hide_compare_price = "";
            let price_style = "";
            let hide_discount = "";

            if (Shopify.currency.active === "EUR") {
              handle = "/" + window.location.pathname.split("/")[1];
              hide_compare_price = "!hidden";
              hide_discount = "!hidden";
              price_style = "!text-[12px] text-black font-medium";
            }

            if (window.location.pathname.includes("search")) {
              location = handle + "/products/" + hit.handle;
            } else {
              location = window.location.pathname + "/products/" + hit.handle;
            }

            const metafieldProduct = hit?.meta?.product || {};
            const fallbackProductImage = metafieldProduct.product_images?.[0] ?? metafieldProduct.original_product_images?.[0];
            const imageFlip =
              metafieldProduct.original_product_images?.[1] || imgsrc;

            return html`
              <div
                class="ais-hit ais-product"
                data-algolia-index="${hit.index}"
                data-algolia-position="${hit.productPosition}"
                data-algolia-queryid="${hit.queryID}"
                data-algolia-objectid="${hit.objectID}"
                data-handle="${hit.handle}"
                data-variant-id="${hit.objectID}"
                data-distinct="${hit._distinct}"
                data-product-id="${hit.id}"
              >
                <a
                  data-algolia-index="${hit.index}"
                  data-algolia-position="${hit.productPosition}"
                  data-algolia-queryid="${hit.queryID}"
                  data-algolia-objectid="${hit.objectID}"
                  title="${algoliaShopify.helpers.fullTitle(
                    hit.title,
                    hit._distinct,
                    hit.variant_title
                  )}"
                  href="${location}"
                >
                  <img
                    class="ais-hit--picture"
                    data-image-original="${imgsrc}"
                    data-image-hover="${imageFlip}"
                    src="${imgsrc}"
                    onerror="${(event) => {
                      event.target.src =
                        fallbackProductImage ||
                        "http://cdn.shopify.com/s/images/admin/no-image-compact.gif";
                    }}"
                    alt="${hit.title} - ${hit.variant_title}"
                  />

                  <div class="ais-hit--details">
                    <p class="ais-hit--title">
                      ${components.Highlight({ attribute: "title", hit })}
                    </p>
                    <p
                      class="ais-hit--subtitle"
                      title="${
                        hit.product_type
                      }${algoliaShopify.translation_helpers.by(hit.vendor)}"
                    >
                      ${components.Highlight({
                        attribute: "product_type",
                        hit,
                      })}
                      ${
                        hit.vendor &&
                        html` <span> ${algoliaShopify.translations.by} </span> `
                      }
                      ${
                        hit.vendor &&
                        components.Highlight({ attribute: "vendor", hit })
                      }
                    </p>
                    <p class="ais-hit--price">
                    ${html`
                      <span class="${hide_compare_price} ais-hit--price-striked">
                        <span>${customDisplayStrikedPrice(
                          hit.variants_min_price,
                          hit.variants_compare_at_price_min
                        )}</span>
                      </span>
                    `}
                  <b class="${price_style} realPrice">${customDisplayPrice(
              hit,
              hit._distinct
            )}</b>
                  
                  ${
                    hit.variants_compare_at_price_min > hit.variants_min_price
                      ? html`
                        <span class="ais-hit--discount ${hide_discount}">
                         ${Math.floor(
                           ((hit.variants_compare_at_price_min -
                             hit.variants_min_price) /
                             hit.variants_compare_at_price_min) *
                             100
                         )}%
                        </span>
                      `
                      : ""
                  }
                </p>
                    <!-- Extra info examples - Remove the display: none to show them -->
                    <p class="ais-hit--info" style="display: none">
                      ${
                        hit.sku &&
                        html`
                        <span class="algolia-sku"
                          >${components.Highlight({
                            attribute: "sku",
                            hit,
                          })}</span
                        >
                      `
                      }
                      ${
                        hit.barcode &&
                        html`
                        <span class="algolia-barcode"
                          >${components.Highlight({
                            attribute: "barcode",
                            hit,
                          })}</span
                        >
                      `
                      }
                      ${
                        hit.weight &&
                        html` <span class="algolia-weight">${hit.weight}</span> `
                      }
                      ${
                        !hit.taxable &&
                        html`
                        <span class="algolia-taxable"
                          >${algoliaShopify.translations.taxFree}</span
                        >
                      `
                      }
                    </p>
                    <!-- Tags example - Remove the display: none to show them -->
                    <p class="ais-hit--tags" style="display: none">
                      ${hit?._highlightResult.tags?.map(
                        (tag) =>
                          html` <span class="ais-hit--tag">${tag.value}</span> `
                      )}
                    </p>
                    ${
                      !hit._distinct &&
                      html`
                      <form
                        id="algolia-add-to-cart-${hit.objectID}"
                        style="display: none;"
                        action="/cart/add"
                        method="post"
                        enctype="multipart/form-data"
                      >
                        <input
                          type="hidden"
                          name="id"
                          value="${hit.objectID}"
                        />
                      </form>
                      <p class="ais-hit--cart">
                        ${
                          hit.can_order
                            ? html`
                              <button
                                class="ais-hit--cart-button"
                                data-form-id="algolia-add-to-cart-${hit.objectID}"
                              >
                                ${algoliaShopify.translations.addToCart}
                              </button>
                            `
                            : html`
                              <button
                                class="ais-hit--cart-button ais-hit--cart-button__disabled"
                              >
                                ${algoliaShopify.translations.outOfStock}
                              </button>
                            `
                        }
                      </p>
                    `
                    }
                  </div>
                </a>
              </div>
            `;
          }
          return templateProduct(hit, html, components);
        },
        empty(results, { html }) {
          return window.algoliaShopify.instantsearch.templates.instantSearchNoResultTemplate(
            html,
            window.algoliaShopify
          );
        },
        showMoreText: "LOAD MORE",
      },
      transformItems: (items) => {
        const transformedItems = items.map((item) => ({
          ...item,
          _distinct: false,
          can_order:
            item.inventory_policy === "continue" || item.inventory_quality > 0,
          queryID: item._queryID,
          productPosition: item._position,
          index:
            window.algoliaShopify.instantsearch.search.mainIndex.getIndexName(),
        }));
        return transformedItems;
      },
      cache: sessionStorageCache,
    });
    const { sortBy } = algoliaShopify.externals.widgets;
    const sortWidget = sortBy({
      container: document.querySelector(".ais-search-header"),
      items: [
        {
          label: "Relevance",
          value: "shopify_products",
        },
        {
          label: "Best Sellers",
          value: "shopify_products_best_sellers",
        },
        {
          label: "New In",
          value: "shopify_products_published_at_desc",
        },
        {
          label: "Price: Low to High",
          value: "shopify_products_price_asc",
        },
        {
          label: "Price: High to Low",
          value: "shopify_products_price_desc",
        },
        {
          label: "Discount: High to Low",
          value: "shopify_products_discount_desc",
        },
      ],
    });

    const statsWidget = stats({
      container: document.querySelector(".ais-stats-container"),
      templates: {
        text(data, { html }) {
          let count = "";

          if (data.hasManyResults) {
            if (data.areHitsSorted) {
              if (data.nbSortedHits >= 24) {
                let estimatedhits = data.hitsPerPage * (1 + data.page);
                let truehits =
                  estimatedhits > data.nbSortedHits
                    ? data.nbSortedHits
                    : estimatedhits;
                count += `1 - ${truehits} of ${data.nbSortedHits} products`;
              } else {
                count += `1 - ${data.nbSortedHits} of ${data.nbSortedHits} products`;
              }
            } else {
              if (data.nbHits >= 24) {
                let estimatedhits = data.hitsPerPage * (1 + data.page);
                let truehits =
                  estimatedhits > data.nbHits ? data.nbHits : estimatedhits;
                count += `1 - ${truehits} of ${data.nbHits} products`;
              } else {
                count += `1 - ${data.nbHits} of ${data.nbHits} products`;
              }
            }
          } else if (data.hasOneResult) {
            count += `1 result`;
          } else {
            count += `no result`;
          }

          return html``;
        },
      },
    });

    return [sortWidget, statsWidget, infiniteHitsWidget];
  });

  algoliaShopify.hooks.registerHook(
    "afterISStartRemoveDefaultWidget",
    function (defaultWidget) {
      const hitsWidget = defaultWidget.find(
        (widget) => widget.$$widgetType === "ais.hits"
      );
      const paginationWidget = defaultWidget.find(
        (widget) => widget.$$widgetType === "ais.pagination"
      );
      const statsWidget = defaultWidget.find(
        (widget) => widget.$$widgetType === "ais.stats"
      );
      return [hitsWidget, paginationWidget, statsWidget];
    }
  );

  algoliaShopify.hooks.registerHook(
    "beforeInstantSearchProductTemplate",
    function (_defaultTemplate, hit, html, components) {
      const customDisplayPrice = function (product, t) {
        var priceInCents = product.variants_min_price * 100;

        if (
          typeof Shopify !== "undefined" &&
          typeof Shopify.currency !== "undefined" &&
          typeof Shopify.currency.rate !== "undefined" &&
          typeof Shopify.currency.active !== "undefined"
        ) {
          // Convert to "presentment" currency using the rate provided by Shopify
          priceInCents = priceInCents * Shopify.currency.rate;
          // Round up to the nearest whole number keeping in accordance with
          // the default rounding strategy of Shopify
          priceInCents = Math.ceil(priceInCents);
        }

        if (Shopify.currency.active === "EUR") {
          var vat = (priceInCents * 22) / 100;
          priceInCents = priceInCents + vat;
        }

        /* Shopify uses different rounding strategies for different currencies.
         * The logic below might need to be customised based on the active currencies.
         * Note: Please only include currencies other than your store currency.
         */
        // Round up to the 95th cent for EUR
        if (Shopify.currency.active === "EUR") {
          priceInCents = parseInt(priceInCents / 100, 10) * 100 + 95;
        }

        var finalPrice = priceInCents / 100;

        if (
          ["HKD", "SGD", "CAD", "GBP", "AUD"].includes(Shopify.currency.active)
        ) {
          finalPrice = Math.ceil(finalPrice).toFixed(2);
        } else if (Shopify.currency.active === "USD") {
          finalPrice = finalPrice.toFixed(2);
        } else {
          finalPrice = finalPrice.toFixed(2);
        }
        var priceFmt = String(finalPrice) // always two decimal digits
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        return window.Shopify.currency.active + " " + priceFmt;
      };

      const customDisplayStrikedPrice = function (final_price, compare_price) {
        var price =
          (compare_price > final_price ? compare_price : final_price) *
          window.Shopify.currency.rate;

        if (
          ["HKD", "SGD", "CAD", "GBP", "AUD"].includes(Shopify.currency.active)
        ) {
          price = Math.ceil(price).toFixed(2);
        } else if (Shopify.currency.active === "USD") {
          price = price.toFixed(2);
        } else {
          price = price.toFixed(2);
        }
        var priceFmt = String(price) // always two decimal digits
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        return window.Shopify.currency.active + " " + priceFmt;
      };

      let imgsrc = algoliaShopify.helpers.largeImage(hit);
      if (
        imgsrc ===
          "http://cdn.shopify.com/s/images/admin/no-image-compact.gif" ||
        !imgsrc
      ) {
        if (hit.meta?.product?.product_images[0]) {
          imgsrc = hit.meta.product.product_images[0];
        }
      }

      let location;
      let handle = "";
      let hide_compare_price = "";
      let price_style = "";

      if (Shopify.currency.active === "EUR") {
        handle = "/" + window.location.pathname.split("/")[1];
        hide_compare_price = "!hidden";
        price_style = "!text-[12px] text-black font-medium";
      }

      if (window.location.pathname.includes("search")) {
        location = handle + "/products/" + hit.handle;
      } else {
        location = window.location.pathname + "/products/" + hit.handle;
      }

      const metafieldProduct = hit?.meta?.product || {};
      const fallbackProductImage = metafieldProduct.product_images?.[0];
      const imageFlip = metafieldProduct.product_images?.[1] || imgsrc;

      return html`
        <div
          class="ais-hit ais-product"
          data-algolia-index="${hit.index}"
          data-algolia-position="${hit.productPosition}"
          data-algolia-queryid="${hit.queryID}"
          data-algolia-objectid="${hit.objectID}"
          data-handle="${hit.handle}"
          data-variant-id="${hit.objectID}"
          data-distinct="${hit._distinct}"
          data-product-id="${hit.id}"
        >
          <a
            data-algolia-index="${hit.index}"
            data-algolia-position="${hit.productPosition}"
            data-algolia-queryid="${hit.queryID}"
            data-algolia-objectid="${hit.objectID}"
            title="${algoliaShopify.helpers.fullTitle(
              hit.title,
              hit._distinct,
              hit.variant_title
            )}"
            href="${location}"
          >
            <img
              class="ais-hit--picture"
              data-image-original="${imgsrc}"
              data-image-hover="${imageFlip}"
              src="${imgsrc}"
              onerror="${(event) => {
                event.target.src =
                  fallbackProductImage ||
                  "http://cdn.shopify.com/s/images/admin/no-image-compact.gif";
              }}"
              alt="${hit.title} - ${hit.variant_title}"
            />

            <div class="ais-hit--details">
              <p class="ais-hit--title">
                ${components.Highlight({ attribute: "title", hit })}
              </p>
              <p
                class="ais-hit--subtitle"
                title="${
                  hit.product_type
                }${algoliaShopify.translation_helpers.by(hit.vendor)}"
              >
                ${components.Highlight({ attribute: "product_type", hit })}
                ${
                  hit.vendor &&
                  html` <span> ${algoliaShopify.translations.by} </span> `
                }
                ${
                  hit.vendor &&
                  components.Highlight({ attribute: "vendor", hit })
                }
              </p>
             <p class="ais-hit--price">
                   ${html`
                    <span class="${hide_compare_price} ais-hit--price-striked">
                      <span>${customDisplayStrikedPrice(
                        hit.variants_min_price,
                        hit.variants_compare_at_price_min
                      )}</span>
                    </span>
                  `}
                  <b class="${price_style} realPrice">${customDisplayPrice(
        hit,
        hit._distinct
      )}</b>
                  ${
                    hit.variants_compare_at_price_min > hit.variants_min_price
                      ? html`
                        <span class="ais-hit--discount ${hide_discount}">
                         ${Math.floor(
                           ((hit.variants_compare_at_price_min -
                             hit.variants_min_price) /
                             hit.variants_compare_at_price_min) *
                             100
                         )}%
                        </span>
                      `
                      : ""
                  }
                </p>
              <!-- Extra info examples - Remove the display: none to show them -->
              <p class="ais-hit--info" style="display: none">
                ${
                  hit.sku &&
                  html`
                  <span class="algolia-sku"
                    >${components.Highlight({ attribute: "sku", hit })}</span
                  >
                `
                }
                ${
                  hit.barcode &&
                  html`
                  <span class="algolia-barcode"
                    >${components.Highlight({
                      attribute: "barcode",
                      hit,
                    })}</span
                  >
                `
                }
                ${
                  hit.weight &&
                  html` <span class="algolia-weight">${hit.weight}</span> `
                }
                ${
                  !hit.taxable &&
                  html`
                  <span class="algolia-taxable"
                    >${algoliaShopify.translations.taxFree}</span
                  >
                `
                }
              </p>
              <!-- Tags example - Remove the display: none to show them -->
              <p class="ais-hit--tags" style="display: none">
                ${hit?._highlightResult.tags?.map(
                  (tag) =>
                    html` <span class="ais-hit--tag">${tag.value}</span> `
                )}
              </p>
              ${
                !hit._distinct &&
                html`
                <form
                  id="algolia-add-to-cart-${hit.objectID}"
                  style="display: none;"
                  action="/cart/add"
                  method="post"
                  enctype="multipart/form-data"
                >
                  <input type="hidden" name="id" value="${hit.objectID}" />
                </form>
                <p class="ais-hit--cart">
                  ${
                    hit.can_order
                      ? html`
                        <button
                          class="ais-hit--cart-button"
                          data-form-id="algolia-add-to-cart-${hit.objectID}"
                        >
                          ${algoliaShopify.translations.addToCart}
                        </button>
                      `
                      : html`
                        <button
                          class="ais-hit--cart-button ais-hit--cart-button__disabled"
                        >
                          ${algoliaShopify.translations.outOfStock}
                        </button>
                      `
                  }
                </p>
              `
              }
            </div>
          </a>
        </div>
      `;
    }
  );
  algoliaShopify.hooks.registerHook(
    "beforeInstantSearchFacetLimitNumber",
    function (limit) {
      limit = 1000;
      return limit;
    }
  );
});


function initializeCustomListeners() {
  const facets = document.querySelector(".ais-facets");
  const openBtn = document.querySelector(".ais-facets-button");
  const closeBtn = document.querySelector(".ais-facets-button-close");
  const facetsButton = document.querySelector(".ais-facets-button");
  const algoliaPage = document.querySelector(".ais-page");
  
  // Create and insert overlay element before the facets
  let overlay = document.querySelector('.ais-facets-overlay');
  if (!overlay) {
    overlay = document.createElement('div');
    overlay.className = 'ais-facets-overlay';
    document.body.appendChild(overlay);
  }

  if (facetsButton && algoliaPage) {
    algoliaPage.prepend(facetsButton);
  }

  function closeFacetsPanel() {
    if (facets.classList.contains("ais-facets__shown")) {
      facets.classList.remove("ais-facets__shown");
      overlay.classList.remove("shown");
      setTimeout(() => {
        facets.style.display = "none";
        openBtn.textContent = "Show Filters";
      }, 300);
    }
  }

  if (facets && openBtn && closeBtn) {
    openBtn.addEventListener("click", function () {
      facets.classList.remove("ais-facets__shown");
      facets.style.display = "block";
      requestAnimationFrame(() => {
        facets.classList.add("ais-facets__shown");
        overlay.classList.add("shown");
      });
      openBtn.textContent = "Hide Filters";
    });

    closeBtn.addEventListener("click", function () {
      closeFacetsPanel();
    });
  }

  // Handle duplicate Apply buttons - observe DOM changes
  const observer = new MutationObserver((mutations) => {
    const existingApplyButtons = document.querySelectorAll('.ais-facets-button-apply');
    if (existingApplyButtons.length > 1) {
      existingApplyButtons.forEach((button, index) => {
        if (index > 0) button.remove();
      });
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  document.addEventListener("click", function (event) {
    // First, check if this is an individual filter removal
    const isFilterRemoveButton = event.target.closest('.ais-CurrentRefinements-delete, .ais-current-refined-values--item');
    const isClearAll = event.target.closest('.ais-ClearRefinements-button');

    // NEVER close panel when removing individual filters
    if (isFilterRemoveButton && !isClearAll) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    // Handle clear all - this should close the panel
    if (isClearAll) {
      closeFacetsPanel();
      return;
    }

    // Handle clicks inside the facets panel
    const isInsidePanel = event.target.closest('.ais-facets.ais-facets__shown');
    if (isInsidePanel) {
      return;
    }

    // Check if clicking inside filter elements (for normal filter interactions)
    const isFilterInteraction = event.target.closest([
      '.ais-RefinementList',
      '.ais-RefinementList-item',
      '.ais-RefinementList-label',
      '.ais-RefinementList-checkbox',
      '.ais-RefinementList-count',
      '.ais-SearchBox',
      '.ais-SearchBox-input',
      '.ais-SearchBox-submit',
      '.ais-SearchBox-reset',
      '.ais-RangeInput',
      '.ais-RangeInput-input'
    ].join(','));

    if (isFilterInteraction) {
      return;
    }

    if (isFilterInteraction) {
      event.stopPropagation();
      return;
    }

    // Ignore clicks on any Algolia-related elements inside the facets
    const isAlgoliaElement = event.target.closest([
      '.ais-RefinementList-item',
      '.ais-RefinementList-label',
      '.ais-RefinementList-checkbox',
      '.ais-RefinementList-count',
      '.ais-ClearRefinements',
      '.ais-SearchBox',
      '.ais-SearchBox-input',
      '.ais-SearchBox-submit',
      '.ais-SearchBox-reset',
      '.ais-RangeInput',
      '.ais-RangeInput-input',
      '.ais-CurrentRefinements',
      '.ais-CurrentRefinements-item',
      '.ais-CurrentRefinements-label',
      '.ais-RefinementList-searchBox'
    ].join(','));

    if (isAlgoliaElement) {
      return;
    }

    // Handle overlay clicks
    if (event.target.classList.contains('ais-facets-overlay')) {
      closeFacetsPanel();
      return;
    }

    // Handle clicks on Apply/Close buttons or outside
    const clickedOnApplyClose = event.target.closest(".ais-facets-button-apply, .ais-facets-button-close");
    const clickedOnFilterButton = event.target.closest(".ais-facets-button");
    const clickedInsideFacets = event.target.closest(".ais-facets");
    const clickedOnOverlay = event.target.classList.contains('ais-facets-overlay');

    // Close panel ONLY when:
    // 1. Clicking Apply/Close buttons
    // 2. Clicking the overlay
    // 3. Clicking completely outside (not on any facet-related element)
    if (clickedOnApplyClose || 
        clickedOnOverlay || 
        (!clickedInsideFacets && !clickedOnFilterButton && !event.target.closest('.ais-CurrentRefinements, .ais-current-refined-values-container'))) {
      if (facets.classList.contains("ais-facets__shown")) {
        closeFacetsPanel();
      }
    }
  });

  // 2. Logika untuk Efek Hover Gambar (Tidak berubah)
  document.addEventListener("mouseover", function (e) {
    const pictureElement = e.target.closest(".ais-hit--picture");
    if (pictureElement) {
      const hoverImage = pictureElement.getAttribute("data-image-hover");
      if (hoverImage && pictureElement.src !== hoverImage) {
        pictureElement.src = hoverImage;
      }
    }
  });
  document.addEventListener("mouseout", function (e) {
    const pictureElement = e.target.closest(".ais-hit--picture");
    if (pictureElement) {
      const originalImage = pictureElement.getAttribute("data-image-original");
      if (originalImage) {
        pictureElement.src = originalImage;
      }
    }
  });

  // 3. Logika untuk Efek Sticky Tombol Filter (Tidak berubah)
  const stickyButton = document.querySelector(".ais-facets-button");
  if (stickyButton) {
    const header = document.querySelector("header");
    const originalOffset =
      stickyButton.getBoundingClientRect().top + window.scrollY;
    let lastScrollTop = window.scrollY;
    let isFixed = false;
    const handleScroll = () => {
      const currentOriginalLeft = stickyButton.getBoundingClientRect().left;
      const currentOriginalWidth = stickyButton.offsetWidth;
      const scrollTop = window.scrollY;
      const isScrollingUp = scrollTop < lastScrollTop;
      const headerHeight = header.offsetHeight;
      if (scrollTop > originalOffset && isScrollingUp) {
        if (!isFixed) {
          Object.assign(stickyButton.style, {
            position: "fixed",
            marginTop: "0",
            left: `${currentOriginalLeft}px`,
            width: `${currentOriginalWidth}px`,
            zIndex: "9999",
            opacity: "0",
            top: `${headerHeight - 10}px`,
            transition: "top 200ms, opacity 200ms",
          });
          requestAnimationFrame(() => {
            stickyButton.style.top = `${headerHeight}px`;
            stickyButton.style.opacity = "1";
          });
          isFixed = true;
        }
      } else {
        if (isFixed) {
          stickyButton.style.opacity = "0";
          setTimeout(() => {
            stickyButton.removeAttribute("style");
          }, 200);
          isFixed = false;
        }
      }
      lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    };
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleScroll);
  }
}

window.addEventListener('load', function() {
  setTimeout(initializeCustomListeners, 1500); 
});